import { render, staticRenderFns } from "./splitRoom.vue?vue&type=template&id=7d7b70e6&scoped=true"
import script from "./splitRoom.vue?vue&type=script&lang=js"
export * from "./splitRoom.vue?vue&type=script&lang=js"
import style0 from "./splitRoom.vue?vue&type=style&index=0&id=7d7b70e6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d7b70e6",
  null
  
)

export default component.exports